import { render, staticRenderFns } from "./VModalCoachItem.vue?vue&type=template&id=8a220e66&scoped=true&"
import script from "./VModalCoachItem.vue?vue&type=script&lang=ts&"
export * from "./VModalCoachItem.vue?vue&type=script&lang=ts&"
import style0 from "./VModalCoachItem.vue?vue&type=style&index=0&id=8a220e66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a220e66",
  null
  
)

export default component.exports